<template>
  <!-- <div id="loginComponent">
    <v-content>
      <v-container fluid fill-height align-center>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card color="transparent" class="color-transparent">
               <div class="space">
                 <img src="../assets/login/logo_intekel.png" height="150px">
               </div>
              <v-card-text >
                <v-alert :value="error" color="error" icon="warning" outline
                  transition="scale-transition">
                  {{errorMessage}}
                </v-alert>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-text-field color="primary" @keyup.enter="validate" v-model="email" :rules="emailRules" required prepend-icon="person"
                    name="Email" :label="$t('general.email')" type="text">
                  </v-text-field>
                  <v-text-field color="primary" @keyup.enter="validate" v-model="password" :rules="passwordRules" required id="password"
                    prepend-icon="lock" name="password" :label="$t('login.password')" type="password" >
                  </v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="validate($event)" color="primary" class="white--text body-2" dark>{{ $t('login.label') }}<v-icon dark>chevron_right</v-icon></v-btn>
              </v-card-actions>
              <v-progress-linear :indeterminate="loading"></v-progress-linear>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </div> -->
  <!-- Start Login -->
  <div>
    <transition name="fade" mode="out-in" appear>
      <div class="vh-100 ">
        <b-row class="h-100 no-gutters ">
          <b-col lg="7" class="d-lg-block custom-login-background">
            <div class="">
              <slick ref="slick" :options="slickOptions">
                <div class="position-relative vh-100 d-flex justify-content-center align-items-center bg-decorated background-animation">
                  <!-- DISEÑO -->
                  <div class="square"></div>
                  <div class="square"></div>
                  <div class="square"></div>
                  <div class="square"></div>
                  <div class="square"></div>
                  <div class="circle"></div>
                  <div class="circle"></div>
                  <div class="circle"></div>
                  <div class="circle"></div>
                  <div class="circle"></div>
                  <div class="triangle"></div>
                  <div class="triangle"></div>
                  <div class="triangle"></div>
                  <div class="triangle"></div>
                  <div class="triangle"></div>
                  <!-- /DISEÑO -->
                  <div class="top-lines"></div>
                  <div class="slider-content" >
                    <h1 class="text-white title-login tracking-in-expand-forward-top">BLUESPEND</h1>
                    <div class="features-grid">
                      <b-row>
                        <b-col cols="6" class="align-items-center b-col-padding">
                          <v-icon color="white" class="mr-3 blur-in-expand" size="50">mdi-cellphone</v-icon>
                          <h1 class="text-white text-size tracking-in-expand">{{ $t('login.portability') }}</h1>
                        </b-col>
                        <b-col cols="6" class="align-items-center b-col-padding">
                          <v-icon color="white" class="mr-3 blur-in-expand" size="50">mdi-tablet-cellphone</v-icon>
                          <h1 class="text-white text-size tracking-in-expand">{{ $t('login.mobilePlatform') }} </h1>
                        </b-col>
                        <b-col cols="6" class="align-items-center b-col-padding">
                          <v-icon color="white" class="mr-3 blur-in-expand" size="50">mdi-clock-outline</v-icon>
                          <h1 class="text-white text-size tracking-in-expand">{{ $t('login.availability') }} </h1>
                        </b-col>
                        <b-col cols="6" class="align-items-center b-col-padding">
                          <v-icon color="white" class="mr-3 blur-in-expand" size="50">mdi-chart-line</v-icon>
                          <h1 class="text-white text-size tracking-in-expand">{{ $t('login.continuousImprovement') }} </h1>
                        </b-col>
                        <b-col cols="6" class="align-items-center b-col-padding">
                          <v-icon color="white" class="mr-3 blur-in-expand" size="50">mdi-file-chart</v-icon>
                          <h1 class="text-white text-size tracking-in-expand">{{ $t('login.reportsAndStatistics') }} </h1>
                        </b-col>
                        <b-col cols="6" class="align-items-center b-col-padding">
                          <v-icon color="white" class="mr-3 blur-in-expand" size="50">mdi-account-check</v-icon>
                          <h1 class="text-white text-size tracking-in-expand">{{ $t('login.accompaniment') }}</h1>
                        </b-col>
                        <b-col cols="12" class="align-items-center b-col-padding">
                          <v-icon color="white" class="mr-3 blur-in-expand" size="50">mdi-cloud-outline</v-icon>
                          <h1 class="text-white text-size tracking-in-expand">{{ $t('login.StoringData') }} </h1>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                  <div class="bottom-lines"></div>
                </div>
              </slick>
            </div>
          </b-col>
          <b-col class="vh-100 d-flex bg-white justify-content-center align-items-center" lg="5" md="12">
            <b-col lg="9" md="10" sm="12" class="mx-auto app-login-box">
              <b-row align-h="center" class="mb-3 mt-n4">
                <img src="../assets/login/logo_intekel.png" height="150px" />
              </b-row>
              <h4 class="mb-0">
                <div>{{ $t('login.welcome') }}</div>
                <span>{{ $t('login.signInToAccount') }}</span>
              </h4>
              <v-alert :value="error" color="error" icon="warning" outline
                transition="scale-transition">
                {{errorMessage}}
              </v-alert>
              <div class="divider" />
              <div>
                <Form>
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <b-row form>
                      <b-col md="12">
                        <!-- QUITADO LO DE MULTICOMPAÑIAS -->
                        <!-- :disabled="companies.length > 0" -->
                        <v-text-field
                          @keyup.enter="validate"
                          v-model="email"
                          :rules="rules.email"
                          :label="$t('general.email')"
                          name="Email"
                          type="text"
                          color="primary"
                          required
                          prepend-icon="person"
                        />
                      </b-col>

                      <b-col md="12">
                        <v-text-field
                          @keyup.enter="validate"
                          @click:append="visibility = !visibility"
                          v-model="password"
                          :label="$t('login.password')"
                          :rules="rules.required"
                          :append-icon="visibility ? 'visibility_off' : 'visibility'"
                          :type="visibility ? 'text' : 'password'"
                          color="primary"
                          required
                          id="password"
                          prepend-icon="lock"
                          name="password"
                        />
                      </b-col>
                      <!-- Botón de login -->
                      <b-col md="12" class="mt-2">
                        <!-- QUITADO LO DE MULTICOMPAÑIAS -->
                         <!-- @click="getCompany" -->
                        <v-btn @click="validate" :loading="loading" block color="primary" class="white--text rounded-pill">
                          {{ $t('login.label') }}
                          <v-icon dark>chevron_right</v-icon>
                        </v-btn>
                      </b-col>
                      <!-- Recuperar contraseña -->
                      <b-col md="12" class="mt-2">
                        <v-btn @click="$router.push('forgot-password')" text block class="text-primary rounded-pill">
                          {{ $t('login.recoverPassword') }}
                        </v-btn>
                      </b-col>
                    </b-row>

                    <!-- Botones de selección de empresa -->
                     <!-- QUITADO LO DE MULTICOMPAÑIAS -->
                  <!-- <div v-if="companies.length > 0" class="mt-4 scroll-container">
                   <v-btn v-for="company in companies"
                     @click="validate(company.email)"
                     :key="company.id"
                     :disabled="loading"
                     class="custom-btn mb-2"
                     block
                   >
                     <i class="fa fa-building icon-color" />
                     <span class="ml-2">{{ company.company[0].name }}</span>
                   </v-btn>
                 </div> -->

                  <br/>
                  <b-col md="12" class="mt-2 text-center">
                   <a href="https://intekelfinancer.com/soporte" class="text-primary font-weight-medium d-block">
                     <v-icon small class="mr-1">mdi-help-circle-outline</v-icon>
                     {{ $t('support.title') }}
                   </a>
                 </b-col>
                 <b-col md="12" class="mt-2 text-center">
                   <a href="https://intercambios.ifo.com.mx/" class="text-primary font-weight-medium d-block">
                     {{ $t('login.inspectructRef') }}
                   </a>
                 </b-col>
                  </v-form>
                </Form>
              </div>
            </b-col>
          </b-col>
        </b-row>
      </div>
    </transition>
  </div>
  <!-- End Login -->
  <!-- Start Login Boxed -->
  <!-- <div>
    <div class="h-100 bg-plum-plate bg-animation" style="height: 100vh !important;">
      <div class="d-flex h-100 justify-content-center align-items-center">
        <b-col md="8" class="mx-auto app-login-box">
          <div class="modal-dialog w-100 mx-auto">
            <div class="modal-content">
              <div class="modal-body">
                <b-row align-h="center">
                  <img src="../assets/login/logo_intekel.png" height="150px" />
                </b-row>
                <v-alert :value="error" color="error" icon="warning" outline
                  transition="scale-transition">
                  {{errorMessage}}
                </v-alert>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-text-field color="primary" @keyup.enter="validate" v-model="email" :rules="emailRules" required prepend-icon="person"
                    name="Email" :label="$t('general.email')" type="text">
                  </v-text-field>
                  <v-text-field color="primary" @keyup.enter="validate" v-model="password" :rules="passwordRules" required id="password"
                    prepend-icon="lock" name="password" :label="$t('login.password')" type="password" >
                  </v-text-field>
                </v-form>
              </div>
              <div class="modal-footer clearfix">
                <v-btn @click="validate($event)" color="primary" class="white--text body-2" dark :loading="loading">{{ $t('login.label') }}<v-icon dark>chevron_right</v-icon></v-btn>
              </div>
            </div>
          </div>
          <div class="text-center text-white opacity-8 mt-3">Copyright &copy; Intekel 2019</div>
        </b-col>
      </div>
    </div>
  </div> -->
  <!-- End Login Boxed -->
</template>

<script>
import Slick from 'vue-slick'
export default {
  name: 'loginComponent',
  components: {
    Slick
  },
  data () {
    return {
      valid: true,
      visibility: false,
      email: '',
      password: '',
      error: false,
      errorMessage: '',
      loading: false,
      slickOptions: {
        dots: true,
        infinite: true,
        speed: 500,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        initialSlide: 0,
        autoplay: true,
        adaptiveHeight: true
      },
      slide: 0,
      sliding: null
    }
  },
  methods: {
    validate () {
      this.loading = true
      this.error = false
      if (this.$refs.form.validate()) {
        this.snackbar = true
        this.$emit('login', { email: this.email, password: this.password, context: this })
      } else {
        this.loading = false
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    setError (flag, message) {
      this.error = flag
      this.errorMessage = message
    },
    setLogin (value) {
      this.$emit('setLoginFalse', value)
    },
    handleClick (newTab) {
      this.currentTab = newTab
    },
    next () {
      this.$refs.slick.next()
    },
    prev () {
      this.$refs.slick.prev()
    },
    reInit () {
      this.$nextTick(() => {
        this.$refs.slick.reSlick()
      })
    },
    onSlideStart (slide) {
      this.sliding = true
    },
    onSlideEnd (slide) {
      this.sliding = false
    }
  },
  computed: {
    rules () {
      return this.$validationRules()
    }
  },
  beforeCreate () {
    document.body.className = 'login'
  },
}
</script>

<style>
.color-transparent {
  background: linear-gradient(rgba(240, 239, 240, 0.8),rgba(240, 239, 240, 0.8));
  margin-top: -1cm;
  padding-top: 0.4cm;
}

.space{
  margin-bottom: -0.5cm;
}

.custom-btn {
  border: 2px solid #98a5be;
  border-radius: 12px;
  background-color: white;
  color: #1e3c72;
  text-transform: none;
}

.custom-btn:hover {
  background-color: #E3F2FD;
}

.custom-btn:active {
  background-color: #BBDEFB;
}

.custom-btn .v-btn__content {
  color: #1e3c72;
}

.bg-decorated {
  position: relative;
  background: linear-gradient(#4d93c9, #07a9e0);
  height: 100vh;
  width: 100%;
}

.bg-decorated::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('../assets/login_desing_marco.png') no-repeat center center;
  background-size: 100% 100%;
  opacity: 0.9; 
}

/* Asegura que tu contenido esté encima del fondo */
.slider-content {
  position: relative;
  z-index: 2;
}
 
.b-col-padding {
  padding-top: 1.5rem;
}

.title-login {
  font-size: 4.5rem !important;
  font-weight: bold;
  margin-bottom: 5rem;
}

.icon-circle {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: #1976d2;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

a.text-primary {
  text-decoration: underline;
}

a.text-primary:hover {
color: #0d47a1; 
text-decoration: underline;
}

.scroll-container {
max-height: 200px;
overflow-y: auto;
padding-right: 4px;
}

.text-size {
  font-size: 1.5rem;
}

/* LETRAS E ICONO */
.tracking-in-expand-forward-top{animation:tracking-in-expand-forward-top 0.6s linear both} @keyframes tracking-in-expand-forward-top{0%{letter-spacing:-.2em;transform:translateZ(-700px) translateY(-100px);opacity:0}40%{opacity:.6}100%{transform:translateZ(0) translateY(0);opacity:1}}

.tracking-in-expand{animation:tracking-in-expand 0.6s linear both} @keyframes tracking-in-expand{0%{letter-spacing:-.2em;opacity:0}40%{opacity:.6}100%{opacity:1}}

.blur-in-expand{animation:blur-in-expand 0.6s linear both} @keyframes blur-in-expand{0%{transform:scale(0);filter:blur(12px);opacity:0}100%{transform:scale(1);filter:blur(0);opacity:1}}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
}

@keyframes rotate-slow {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* ----- FIGURA GEOMÉTRICAS ----- */
.square, .circle, .triangle {
  position: absolute;
  opacity: 0.5;
}

.square {
  width: 40px;
  height: 40px;
  background: rgba(255,255,255,0.25);
  animation: float 6s ease-in-out infinite alternate,
             move-random 12s ease-in-out infinite alternate,
             rotate-slow 20s linear infinite,
             fade 5s ease-in-out infinite;
}

.circle {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: rgba(255,255,255,0.2);
  animation: float 8s ease-in-out infinite alternate,
             move-random 15s ease-in-out infinite alternate,
             fade 6s ease-in-out infinite;
}

.triangle {
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 35px solid rgba(255,255,255,0.3);
  animation: float 7s ease-in-out infinite alternate,
             move-random 14s ease-in-out infinite alternate,
             rotate-slow 25s linear infinite,
             fade 5s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-15px); }
}

@keyframes move-random {
  0%   { transform: translate(0, 0); }
  25%  { transform: translate(10px, -5px); }
  50%  { transform: translate(-8px, 10px); }
  75%  { transform: translate(5px, -10px); }
  100% { transform: translate(0, 0); }
}

@keyframes rotate-slow {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes fade {
  0%, 100% { opacity: 0.5; }
  50% { opacity: 0.1; }
}

.square:nth-child(1) { top: 10%; left: 15%; }
.square:nth-child(2) { top: 40%; left: 70%; }
.square:nth-child(3) { top: 80%; left: 30%; }
.square:nth-child(4) { top: 20%; left: 85%; }
.square:nth-child(5) { top: 60%; left: 10%; }

.circle:nth-child(6) { top: 15%; left: 50%; }
.circle:nth-child(7) { top: 50%; left: 80%; }
.circle:nth-child(8) { top: 75%; left: 60%; }
.circle:nth-child(9) { top: 30%; left: 25%; }
.circle:nth-child(10) { top: 90%; left: 40%; }

.triangle:nth-child(11) { top: 5%; left: 5%; }
.triangle:nth-child(12) { top: 25%; left: 65%; }
.triangle:nth-child(13) { top: 55%; left: 35%; }
.triangle:nth-child(14) { top: 70%; left: 85%; }
.triangle:nth-child(15) { top: 85%; left: 15%; }
</style>



// WEBPACK FOOTER //
// src/components/login.component.vue